import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const storedUser = sessionStorage.getItem("user");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Failed to parse user from sessionStorage", error);
      return null;
    }
  });
  const [token, setToken] = useState(sessionStorage.getItem("token") || null);
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);

  useEffect(() => {
    setIsAuthenticated(!!token);
  }, [token]);

  const login = async (loginData) => {
    const { access_token, organizacion, places, user_id, isAdmin, ...userResponse } = loginData;
    const userData = {
      id: user_id,
      ...userResponse,
      user_id: user_id,
      is_admin: isAdmin
    };
    
    setToken(access_token);
    setUser(userData);
    
    sessionStorage.setItem("token", access_token);
    sessionStorage.setItem("user", JSON.stringify(userData));

    if (organizacion) {
      sessionStorage.setItem("organization", JSON.stringify(organizacion));
    }
    if (places && places.length > 0) {
      sessionStorage.setItem("selectedPlaceId", places[0].place_id);
      sessionStorage.setItem("selectedPlaceName", places[0].name_place);
    }
  };

  const logout = () => {
    sessionStorage.clear();
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ token, isAuthenticated, user, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
